import React from 'react';
import {StepData} from './ChapterTaskDrawer'
import {Button, TextField} from "@mui/material";
import * as Yup from 'yup';
import {Field, Form, Formik} from 'formik';

type StepOneProps = {
    data: {
        name: string;
        taskDescription: string;
    };
    onDataChange: (data: Partial<StepData>) => void;
    nextStep: () => void;
};

const validationSchema = Yup.object().shape({
    name: Yup.string().required('Необходимо указать название'),
    taskDescription: Yup.string().required('Необходимо указать описание задания'),
});

const StepOneTask: React.FC<StepOneProps> = ({ data, onDataChange, nextStep  }) => {
    return (
        <div>
            <Formik
                key={data.name + data.taskDescription}
                initialValues={{
                    name: data.name,
                    taskDescription: data.taskDescription,
                }}
                validationSchema={validationSchema}
                onSubmit={(values) => {
                    onDataChange({ step1: values });
                    nextStep();
                }}
            >
                {({ handleChange, handleBlur, values, errors, touched }) => (
                    <Form>
                        <div className="step-one-title">Название задания</div>
                        <div className="step-one-subtitle">Название задания должно быть понятным.</div>
                        <Field
                            as={TextField}
                            variant="outlined"
                            placeholder="Введите название"
                            name="name"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.name}
                            className="without-label"
                            error={touched.name && Boolean(errors.name)}
                            helperText={touched.name && errors.name}
                        />
                        <div className="step-one-title">Описание задания</div>
                        <div className="step-one-subtitle">
                            Описание задания должно включать важные детали для его выполнения, а также закрывать возможные вопросы студента.
                        </div>
                        <Field
                            as={TextField}
                            variant="outlined"
                            placeholder="Введите описание"
                            name="taskDescription"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.taskDescription}
                            className="without-label"
                            error={touched.taskDescription && Boolean(errors.taskDescription)}
                            helperText={touched.taskDescription && errors.taskDescription}
                        />
                        <div className="chapter-drawer-footer-Lacture">
                            <Button
                                variant="contained"
                                type="submit">

                                Далее
                            </Button>
                        </div>
                    </Form>
                )}
            </Formik>
        </div>
    );
};

export default StepOneTask;